//DATA for the app
export const EventType = {
  hourly: { Id: 100046286, Name: 'Online Booking' },
  weekly: { Id: 100046976, Name: 'Online Booking Weekly' },
  monthly: { Id: 100046977, Name: 'Online Booking Monthly' },
  yearly: { Id: 100046978, Name: 'Online Booking Yearly' },
  other: { Id: 100047140, Name: 'Facility Online Booking General' },
  afterhour: { Id: 100047139, Name: 'Online Booking after hour' },
};

export const OrganisationType = {
  Corporate: { Id: 100014520, Name: 'Corporate' },
  NonCommercial: { Id: 100014470, Name: 'NonCommercial' },
  Commercial: { Id: 100014469, Name: 'Commercial' },
  Community: { Id: 100010011, Name: 'Community' },
  General: { Id: 100014519, Name: 'General' },
  Special: { Id: 100014471, Name: 'Special' },
};

export const surchargeRate = 0.0075;

export const searchResultLimit = 5;

export const weeklyDefinition = 5;

export const DefaultOnlineBookingOwnerId = { Id: 100017806 }; // do not swap this one, this is a dummy created in the system

export const DefaultContactType = { Id: 9715, Name: 'Contact' };

export const DefaultEventSource = { Id: 6, Name: 'Website' };

export const DefaultBookingType = { Id: 8199, Name: 'Function' };

export const DefaultBookingStatus = { Id: 8862, Type: 'Reserved' };

export const DefaultInquirySource = { Id: 100006904, Name: 'Web Enquiry' };

export const DefaultOpportunitySource = { Id: 8466, Name: 'Website' };

export const DefaultVenuesList = {
  CatalogueTypeName: 'Venue',
  IncludeInactive: true,
  LastUpdatedDate: '18/08/2021 01:00:00',
};

export const DefaultEventStatus = {
  Type: 'Reserved',
  TextColour: '#000000',
  Color: '#005e00',
  Id: 8862,
  Name: 'Confirmed Casual',
  Colour: '#005e00',
};

export const DefaultEventCoordinator = {
  Type: 'Users',
  PriavaUserId: 100017806, // 100011647 this is the dummy id
  Id: 100017806,
  Name: 'Priava Online Booking Coodinator', ///TODO host information needs to be dynamic or great from the system
  APIUserType: '',
};
// FCHQOptions and FCHQ needs to be linked by KEY

export const FCHQ = {
  hotdesksdd: {
    groupId: 0,
    whatisincluded: [
      'Desk and Chair',
      'Keyboard and Mouse',
      'Monitor',
      'Notepad + pen',
    ],
    maxCapacity: 1,
    venueName: ' Dedicated Hot Desk',
    parentGroupId: 100115899,
    venueIds: [
      100451033, 100451034, 100451035, 100451036, 100451037, 100451038,
      100451039, 100451040, 100451041, 100451042,
    ],
    pricingCatalogue: {
      hourly: 100474582,
      weekly: 100482595,
      monthly: 100482596,
      anually: 100482597,
    },
    account: 33827,
    rtype: 901,
    key: 'hotdesksdd',
    dailyOnly: true,
    allowRecursive: true,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  hotdesks: {
    groupId: 0,
    whatisincluded: ['Desk and Chair', 'Notepad + pen'],
    maxCapacity: 1,
    venueName: 'Hot Desk',
    parentGroupId: 100115899,
    venueIds: [
      100451043, 100451044, 100451045, 100451046, 100451047, 100451048,
      100451049, 100451050, 100451051, 100451052,

      100451053, 100451054, 100451055, 100451056, 100451057, 100451058,
      100451059, 100451060, 100451061, 100451062, 100451063, 100451066,
      100451067, 100451068, 100456316, 100456317, 100474575, 100474576,
      100474577, 100474578,
    ],
    pricingCatalogue: {
      hourly: 100474582,
      weekly: 100482595,
      monthly: 100482596,
      anually: 100482597,
    },
    account: 33827,
    rtype: 901,
    key: 'hotdesks',
    dailyOnly: true,
    allowRecursive: true,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  meetingrooms: {
    groupId: 0,
    whatisincluded: ['Cables e.g HDMI', 'Interactive Screen', 'Notepad + pen'],
    maxCapacity: 8,
    venueName: 'Meeting Spaces',
    parentGroupId: 100115898,
    venueIds: [100451029, 100451030],
    pricingCatalogue: {
      hourly: 100474580,
      weekly: 100482600,
      monthly: 100482601,
      anually: 100482602,
    },
    account: 33822,
    rtype: 901,
    key: 'meetingrooms',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  commnunityhub: {
    groupId: 0,
    whatisincluded: ['TBC'],
    maxCapacity: 60,
    configOptions: [
      'Default',
      'Auditorium',
      'Boardroom',
      'Classroom',
      'Cocktail/Bar',
      'Hollow Square',
      'U-shape',
    ],
    venueName: 'Community Space',
    key: 'communityhub',
    dailyOnly: false,
    allowRecursive: false,
    venueIds: [100456319],
    pricingCatalogue: {
      hourly: 100474581,
      weekly: 100482603,
      monthly: 100482604,
      anually: 100482605,
    },
    account: 33823,
    rtype: 901,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  studio: {
    groupId: 0,
    whatisincluded: [
      'Cables e.g HDMI',
      'Camera (Sony)',
      'Camera Tripod',
      'Gimbal',
      'Headphones',
      'Laptop',
      'Lecturn',
      'Video or Camera',
      'Microphone Lapel, Boom & External',
      'Reflector',
      'Softbox',
      'Video Camera (Sony FX6)',
      'Whiteboard',
    ],
    maxCapacity: 20,
    venueName: 'Studio HQ (Green Screen Studio)',
    venueIds: [100452768],
    pricingCatalogue: {
      hourly: 100474584,
      weekly: 100482609,
      monthly: 100482610,
      anually: 100482611,
    },
    account: 33820,
    rtype: 901,
    key: 'studio',
    dailyOnly: false,
    allowRecursive: false,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },

  audio: {
    groupId: 0,
    whatisincluded: ['Headphones', 'Laptop', 'Recording Device'],
    maxCapacity: 1,
    venueName: 'Audio HQ (Post Production & Audio Suite)',
    key: 'audio',
    dailyOnly: false,
    allowRecursive: false,
    venueIds: [100452770],
    pricingCatalogue: {
      hourly: 100474583,
      weekly: 100482607,
      monthly: 100482606,
      anually: 100482608,
    },
    account: 33821,
    rtype: 901,
    opsHour: {
      fieldOpeningHour: 8,
      fieldCloseHour: 19,
    },
  },
};

